// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBvG8_i2PEQgPgGPArYJ4gp2ke1bKfAWFs",
  authDomain: "delmarva-camp.firebaseapp.com",
  projectId: "delmarva-camp",
  storageBucket: "delmarva-camp.appspot.com",
  messagingSenderId: "257059147796",
  appId: "1:257059147796:web:c55d0a7fa20e385361d701",
  measurementId: "G-1N27F42E7D",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export { db };
